var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.loading)?_c('div',{staticClass:"text-center"},[_c('v-row',{staticStyle:{"height":"100vh"},attrs:{"justify":"center","align":"center"}},[_c('v-col',{staticClass:"text-center mt-7"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"blue","size":"80"}})],1)],1)],1):_c('div',[_c(_vm.view,{tag:"component"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }